import { AccessRuleMethod } from './model'

export const APPLICATION_CREDENTIALS_ROLE_LABEL = {
  admin: 'Administrator',
  member: 'Self-service',
  reader: 'Read Only',
} as const

// HTTP Methods available for access rules
export const HTTP_METHODS: AccessRuleMethod[] = ['GET', 'PUT', 'POST', 'DELETE', 'PATCH']

// Empty access rule template
export const EMPTY_ACCESS_RULE = {
  service: '',
  path: '',
  methods: [] as AccessRuleMethod[],
}
